// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1LLtm","icon":"style_icon__3ohVX","setIcon":"style_setIcon__3mgCg","setIconActive":"style_setIconActive__1kroI","link":"style_link__ElVn5"};